import React from 'react';
import './Team.scss'
import team1 from '../../Images/team1.png'

function Team() {
  return (
      <div id='team'>
          <div className='teamHeader'>
              <h2>MEET THE TEAM</h2>
              <p className='subTitle'>Lorem ipsum dolor sit amet,adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>
          </div>

        <div className='container'>
          <div className='row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-3'>
            <div className='col'>
                <div className='teamCard'>
                    <img className='teamImage' src={team1} alt="Team Image" />
                    <h3 className='memberName'>Arkham NYC</h3>
                    <p className='memberText'>genius, billionaire, playboy, genius, philanthropist</p>
                </div>
            </div>
            <div className='col'>
                <div className='teamCard'>
                    <img className='teamImage' src={team1} alt="Team Image" />
                    <h3 className='memberName'>Arkham NYC</h3>
                    <p className='memberText'>genius, billionaire, playboy, genius, philanthropist</p>
                </div>
            </div>
            <div className='col'>
                <div className='teamCard'>
                    <img className='teamImage' src={team1} alt="Team Image" />
                    <h3 className='memberName'>Arkham NYC</h3>
                    <p className='memberText'>genius, billionaire, playboy, genius, philanthropist</p>
                </div>
            </div>
            <div className='col'>
                <div className='teamCard'>
                    <img className='teamImage' src={team1} alt="Team Image" />
                    <h3 className='memberName'>Arkham NYC</h3>
                    <p className='memberText'>genius, billionaire, playboy, genius, philanthropist</p>
                </div>
            </div>
            <div className='col'>
                <div className='teamCard'>
                    <img className='teamImage' src={team1} alt="Team Image" />
                    <h3 className='memberName'>Arkham NYC</h3>
                    <p className='memberText'>genius, billionaire, playboy, genius, philanthropist</p>
                </div>
            </div>
            <div className='col'>
                <div className='teamCard'>
                    <img className='teamImage' src={team1} alt="Team Image" />
                    <h3 className='memberName'>Arkham NYC</h3>
                    <p className='memberText'>genius, billionaire, playboy, genius, philanthropist</p>
                </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default Team;
